export const typesRound = Object.freeze({
    GOLD: '1',
    COMMON: '2',
});

export const statusesRound = Object.freeze({
    CURRENT: '1',
    COMPLETED: '2',
});
